var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:trash-can"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.833 10.083V14.6663M3.66634 5.49967H18.333L16.8847 18.5347C16.835 18.9833 16.6217 19.3978 16.2854 19.6989C15.9492 19.9999 15.5137 20.1664 15.0623 20.1663H6.93701C6.48567 20.1664 6.05019 19.9999 5.71394 19.6989C5.3777 19.3978 5.16432 18.9833 5.11467 18.5347L3.66634 5.49967ZM6.73259 2.88442C6.88086 2.56998 7.11549 2.30417 7.4091 2.11801C7.7027 1.93185 8.04319 1.833 8.39084 1.83301H13.6085C13.9563 1.83283 14.297 1.93159 14.5908 2.11776C14.8846 2.30394 15.1193 2.56984 15.2677 2.88442L16.4997 5.49967H5.49967L6.73259 2.88442V2.88442ZM1.83301 5.49967H20.1663H1.83301ZM9.16634 10.083V14.6663V10.083Z",
    stroke: "#115BC7",
    strokeWidth: 1.55833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.68bc8fdce0e0932f003893b88b1e56fc.svg";
export { ForwardRef as ReactComponent };